import { render, staticRenderFns } from "./DoctorNoteEdit.vue?vue&type=template&id=397133ab&scoped=true&"
import script from "./DoctorNoteEdit.vue?vue&type=script&lang=js&"
export * from "./DoctorNoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397133ab",
  null
  
)

export default component.exports